import { render, staticRenderFns } from "./softwareCustomized.vue?vue&type=template&id=7f66550e&scoped=true"
import script from "./softwareCustomized.vue?vue&type=script&lang=js"
export * from "./softwareCustomized.vue?vue&type=script&lang=js"
import style0 from "./softwareCustomized.vue?vue&type=style&index=0&id=7f66550e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66550e",
  null
  
)

export default component.exports